import Env from "../environments";
import { GLOBAL_CONSTANTS, UTM_KEYS } from "../global/constants";
import { apiNotificationTracking, apiTracking } from "./api";
import { genULID } from "./slug";
import { getCookie, setCookie } from "./browser";
import "../utils/polyfills";
import { getParamUrl, historyPushState, removeURLParameter } from "./url";
import { LocalStorage } from "../models/LocalStorage";
import { MINI_APP } from "./miniApp";
import { autoScrollInput } from "./input";

const queryString = require('query-string');

export const embedTrackFoe = () => {
  if (Env.DUTY_CAST_TRACKING_URL) {
    const script = document.createElement("script");
    script.src = Env.DUTY_CAST_TRACKING_URL + "&bt=" + Env.DUTY_CAST_BUILD_TIMESTAMP;
    script.async = true;
    document.body.appendChild(script);
  }
}

export const embedGoogleTag = () => {
  if (Env.DUTY_CAST_GOOGLE_TAG_KEY) {
    window.$("head").append(window.$(
      `
    <!-- Google Tag Manager -->
    <script>(function (w, d, s, l, i) {
      w[l] = w[l] || []; w[l].push({
        'gtm.start':
          new Date().getTime(), event: 'gtm.js'
      }); var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', '${Env.DUTY_CAST_GOOGLE_TAG_KEY}');</script>
    <!-- End Google Tag Manager -->
    `
    ));
    window.$("body").prepend(window.$(
      `
    <!-- Google Tag Manager (noscript) -->
    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${Env.DUTY_CAST_GOOGLE_TAG_KEY}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    </noscript>
    <!-- End Google Tag Manager (noscript) -->
    `
    ));
  }
}

export const embedGoogleAnalytic = () => {
  if (Env.DUTY_CAST_GOOGLE_ANALYTIC_KEY) {
    window.$("head").append(window.$(
      `
    <!-- Global site tag (gtag.js) - Google Analytics -->
    <script async
      src="https://www.googletagmanager.com/gtag/js?id=${Env.DUTY_CAST_GOOGLE_ANALYTIC_KEY}"></script>
    <script>
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', '${Env.DUTY_CAST_GOOGLE_ANALYTIC_KEY}');
    </script>
    `
    ));
  }
}

export const embedGoogleAds = () => {
  if (Env.DUTY_CAST_GOOGLE_ADS_KEY) {
    window.$("head").append(window.$(
      `
    <!-- Google tag (gtag.js) - Google Ads -->
    <script async src="https://www.googletagmanager.com/gtag/js?id=${Env.DUTY_CAST_GOOGLE_ADS_KEY}"></script>
    <script>
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
    
      gtag('config', '${Env.DUTY_CAST_GOOGLE_ADS_KEY}');
    </script>
    `
    ));
  }
}

export const sendNotificationState = () => {
  const nid = getParamUrl(GLOBAL_CONSTANTS.NOTIFICATION_ID);
  if (nid) {
    apiNotificationTracking({
      state: GLOBAL_CONSTANTS.NOTIFICATION_STATE.CLICKED,
      id: nid,
    });
    historyPushState(removeURLParameter(window.location.href, GLOBAL_CONSTANTS.NOTIFICATION_ID), true);
  }
}

export const setupUid = () => {
  let uid = getCookie(GLOBAL_CONSTANTS.UID);
  let save = false;
  if (uid === "undefined" || uid === "null") {
    save = true;
    uid = getCookie(GLOBAL_CONSTANTS.UID) || genULID();
  }
  uid = uid ? uid : genULID();
  (save || !LocalStorage.isMiniApp()) && setCookie(GLOBAL_CONSTANTS.UID, uid, 3600 * 24 * 365 * 2, "/");
  return uid;
}

export const embedAllTrack = (ignorePostTrack = false, ignoreUtm = false) => {
  if (!ignoreUtm) {
    handleUtm();
  }
  embedGoogleTag();
  embedGoogleAnalytic();
  embedGoogleAds();
  embedTrackFoe();
  let uid = setupUid();
  if (LocalStorage.isMiniApp()) {
    $("body").addClass("mini-app");
  }

  if (ignorePostTrack) {
    return;
  }
  apiTracking({
    ...getParamUrl(),
    uid
  });
  sendNotificationState();
  autoScrollInput();
  MINI_APP.language = LocalStorage?.getLanguage();
  MINI_APP.shippingCountry = LocalStorage?.getShipping();
  MINI_APP.billingCountry = LocalStorage?.getBilling();
  MINI_APP.currency = LocalStorage?.getCurrency();
  MINI_APP.isLoggedIn = LocalStorage?.isLoggedIn();
}

export const handleUtm = (params) => {
  let hasUtm = false;
  const query = params || getParamUrl();
  for (const [key, value] of Object.entries(query)) {
    if (UTM_KEYS.includes(key) && value) {
      hasUtm = true;
    } else {
      delete query[key];
    }
  }
  if (hasUtm) {
    const search = `?${queryString.stringify(query)}`;
    setCookie(GLOBAL_CONSTANTS.COOKIE.UTM, search, 3600 * 24 * 30, "/");
  }
}

export const removeUtm = () => {
  setCookie(GLOBAL_CONSTANTS.COOKIE.UTM, "", -1, "/");
}

export const getCookieUtmParams = () => {
  const cookie = getCookie(GLOBAL_CONSTANTS.COOKIE.UTM) || "";
  const cookieParam = getParamUrl(undefined, cookie);

  let replace = false;
  for (const [key] of Object.entries(cookieParam)) {
    if (!UTM_KEYS.includes(key)) {
      delete cookieParam[key];
      replace = true;
    }
  }
  if (replace) {
    const search = `?${queryString.stringify(cookieParam)}`;
    setCookie(GLOBAL_CONSTANTS.COOKIE.UTM, search, 3600 * 24 * 30, "/");
  }
  return cookieParam;
}

export function defer(condition, method, relay = 50) {
  if (condition()) {
    method();
  } else {
    setTimeout(function () { defer(condition, method, relay) }, relay);
  }
}